@use '../../list-group/list-group-item/list-group-item-vars';

:host {
  @include list-group-item-vars.wb-list-group-item-vars;

  display: block;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.4;
}

:host([hidden]) {
  display: none;
}

.wb-list-group-item {
  box-sizing: border-box;
}

:host(:not(:last-of-type)) {
  border-block-end-style: solid;
  border-block-end-width: var(--list-group-border-weight);
  border-block-end-color: var(--list-group-item-border-color);
}
